import React from 'react';
import SignatureCanvas from 'react-signature-canvas';

interface SignatureModalProps {
  isOpen: boolean;
  sigCanvasRef: React.RefObject<SignatureCanvas | null>;
  onClose: () => void;
  onClear: () => void;
  onSave: () => void;
}

export const SignatureModal: React.FC<SignatureModalProps> = ({
  isOpen,
  sigCanvasRef,
  onClose,
  onClear,
  onSave,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 font-sans print:hidden">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md border border-gray-200">
        <h3 className="text-base font-bold text-gray-900 mb-3 text-center">
          "လက်မှတ်ထိုးရန်"
        </h3>

        <div className="border-2 border-dashed border-gray-300 rounded-md bg-gray-50 flex justify-center items-center overflow-hidden">
          <SignatureCanvas
            ref={sigCanvasRef}
            penColor="black"
            canvasProps={{
              width: 400,
              height: 180,
              className: 'bg-transparent cursor-crosshair max-w-full',
            }}
          />
        </div>

        <div className="flex justify-between items-center mt-4 gap-3">
          <button
            type="button"
            onClick={onClear}
            className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded transition font-medium"
          >
            🗑️ ရှင်းလင်းမည်
          </button>

          <div className="flex gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm text-gray-500 hover:text-gray-700 font-medium"
            >
              ပယ်ဖျက်
            </button>
            <button
              type="button"
              onClick={onSave}
              className="px-5 py-2 text-sm bg-blue-600 hover:bg-blue-700 text-white font-bold rounded shadow transition"
            >
              💾 သိမ်းဆည်းမည်
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};